import fetch from 'isomorphic-fetch';
import { handleFetchedErrors, headers } from '../utils';
import { polyfill } from 'es6-promise';

polyfill();

export function get(url, callback, error){
	const options = Object.assign({ method: 'GET' }, headers);

	return fetch(url, options)
		.then(handleFetchedErrors)
		.then(response => response.json())
		.then(callback)
		.catch(error);
}



// WEBPACK FOOTER //
// ./react-app-src/shared/services/FetchService.js